import { Button, Flex } from '@welbe/design-system';
import { MoreUser } from 'App/Components/Icons';

type ActionsProps = {
	handleOpenModalAddUser: () => void;
	handleOpenModalAddProfile?: () => void;
};

export const Actions = ({
	handleOpenModalAddProfile,
	handleOpenModalAddUser,
}: ActionsProps) => {
	return (
		<Flex justify="end" gap="1.25rem" w="100%" p="1.875rem 0 1.875rem 2.5rem">
			{!!handleOpenModalAddProfile && (
				<Button
					key="1"
					variant="outline"
					onClick={handleOpenModalAddProfile}
					width="180px"
				>
					Administrar perfiles
				</Button>
			)}
			{!!handleOpenModalAddUser && (
				<Button onClick={handleOpenModalAddUser} width="180px" gap="0.5rem">
					Agregar usuario <MoreUser />
				</Button>
			)}
		</Flex>
	);
};
